<template>
	<BasicLayout :left='left' :middle='middle' :right='right'>
	    <template v-slot:left_view>
	      <div>
	        	<leftTopoTree ref='topotree' :message="receiveGraphNeID" :searchBox='searchBox' :checkBox='checkBox' @sendInfo="receiveTreeMessage" @setGraphType="setGraphType"></leftTopoTree>
	      </div>
	    </template>
	    <template v-slot:right_view>
	    	<!-- this is show SVG-icon -->
			<app-typography-icon />
		    <div>
		        <button-graph ref='baseBtn' @notice='notice' :saveLocBtn='true' :layoutBtn='true' :selectAllBtn='true' :revertBtn='true' :fullScreenBtn='true' :backPreBtn='true' :refreshBtn='true' >
		        </button-graph>
		        <base-physic ref='basePhysicDiagram' :nodes='nodes' :nodesMap="nodesMap" :message="receiveTreeNeID" :graphType="isLogical" :roleNe='roleNetList'
		          	@sendInfo="receiveGraphMessage" @updateTree='updateTreeData' @setTreeOnline='setTreeOnline'>
		        </base-physic>
		    </div>
	    </template>
	</BasicLayout>
</template>

<script>

	import { createNamespacedHelpers } from 'vuex';
	import BasicLayout from '../../../layouts/BasicLayout';

	//-- net element SVG
	import AppTypographyIcon from '@/components/AppTypographyIcon';

	import LeftTopoTree from '@/components/topoconfig/leftTree/LeftTopoTree';
	import BasePhysic from '@/components/topoconfig/BasePhysic';
	import ButtonGraph from '@/components/topoconfig/ButtonGraph';
	import topoMethods from '@/components/topoconfig/TopoCommon';
	import { EventBus } from '../../../plugins/eventBus';

	const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

	export default {
	  	name: 'physicGraph',
	  	components: {
		    BasicLayout,
		    //-- include svg
		    AppTypographyIcon,
		    LeftTopoTree,
		    ButtonGraph,
		    BasePhysic,
		},
  		mixins: [topoMethods],
		mounted() {

			window.onresize = () => {
				// 全屏状态下监听esc事件
				if (!this.checkFull()) {
				this.$parent.menuControl(0);
				this.flag = 1;
				this.$refs.baseBtn.flag = this.flag;
				}
			};

		},

		beforeMount() {
			const This = this;
			// This.roleNetMap = {};
			This.roleNetList = [];
			This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
				if (response && response.status === 200) {
					for (let i = 0; i < response.data.length; i++) {
						// This.roleNetMap[response.data[i]] = 1;
						This.roleNetList.push(response.data[i]);

					}
					this.$refs.baseBtn.queryTopoConfig(This.roleNetList);
				}
			});
			// this.queryTopoConfig();
		},
  		data() {
		    return {
		      left: {
		        show: true,
		        name: this.$t('Topo.elementTree'),
		      },
		      middle: {
		        show: false,
		        name: 'mo'
		      },
		      right: {
		        show: true,
		        crumb: this.$t('Topo.topoManagerAndTopoMonitor'),
		      },
		      searchBox: {
		        show: true,
		      },
		      checkBox: {
		        show: false,
		      },
		      receiveTreeNeID: '',
		      receiveGraphNeID: '',
		      isLogical: '0',
			  nodes: [],
			  roleNetList: [],
			//   showAlarmNumBtn:{ type: Boolean, default: true },
		  };
	  },
	  computed: {
	    ...mapGetters(['physicalNodes', 'logicalNodes', 'getTypeByCode', 'getTopoGraph']),
	  },
	  methods: {
		    ...mapActions(['setPhysical', 'setLogical', 'setParentNe', 'addParentNe', 'delParentNe']),
		    receiveTreeMessage(treeNeID) {
			      this.receiveTreeNeID = treeNeID;
			      this.$refs.basePhysicDiagram.receiveTree(treeNeID);

		    },
		    receiveGraphMessage(graphNeID) {
		     	this.receiveGraphNeID = graphNeID;
		    },
		    notice(type) {
		      switch (type) {
		        case 'saveLocBtn': // 保存位置
		          this.saveLoc();
		          break;
		        case 'excelLayout': // 布局排序
		          this.excelLayout();
		          break;
		        case 'revertScale': // 返回1:1
		          this.revert();
		          break;
		        case 'fullScreen': // 全屏
		          this.fullScreen();
		          break;
		        case 'selectAll': // 全选
		          this.selectAll();
		          break;
		        case 'backPrevious': // 返回上级
		          this.backPrevious();
		          break;
		        case 'refresh': // 刷新树和图
		          this.refresh();
		          break;
		        default:
		          break;
		      }
		    },
		    saveLoc() {
		      this.$refs.basePhysicDiagram.saveLoc();
		    },
		    excelLayout() {
		      this.$refs.basePhysicDiagram.excelLayout();
		    },
		    revert() {
		      this.$refs.basePhysicDiagram.revert();
		    },
		    selectAll() {
		      this.$refs.basePhysicDiagram.selectAll();
		    },
		    backPrevious() {
		      this.$refs.basePhysicDiagram.backPrevious();
		    },
		    refresh() {

		    	this.$refs.basePhysicDiagram.loadElement();
		      this.$refs.topotree.oldSelectedNodes = this.$refs.topotree.selectedNodes = [];
          setTimeout(() => {
            this.$refs.basePhysicDiagram.refresh();
          }, 500)

		    },
		    setLeftDataSource(leftDS){
		    	//-- when left-tree data hyppen change
		    	 this.$refs.basePhysicDiagram.leftDataSource = leftDS;
		    },
		    updateTreeData() {

		    	this.$refs.topotree.oldSelectedNodes = this.$refs.topotree.selectedNodes ;
		      	this.$refs.topotree.getTopoTreeData();
		    },
		 	//--   webSocket更新树状态
		    setTreeOnline(id, isOnline) {
		      	this.$refs.topotree.setOnlineStatus(id, isOnline);
		    },
		    setGraphType(isLogical) {
		      	this.$refs.basePhysicDiagram.refresh(isLogical);
			},
			// queryTopoConfig(){
			// 	const url = "";
			// 	this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
			// 		if (response && response.status === 200) {
			// 			localStorage.removeItem('showAlarmNumBtn');
			// 			if(0==response.data.resultVal[0].alarmNumSet){
			// 				// this.$refs.baseBtn.showAlarmNumBtn = false;
			// 				// this.showAlarmNumBtn = false;
			// 				localStorage.setItem('showAlarmNumBtn', false);
			// 				// EventBus.$emit('showAlarmNumBtn', false);

			// 			}else{
			// 				localStorage.setItem('showAlarmNumBtn', true);
			// 				// this.$refs.baseBtn.showAlarmNumBtn = true;
			// 				// EventBus.$emit('showAlarmNumBtn', true);
			// 				// this.showAlarmNumBtn = true;
			// 				this.$refs.baseBtn.queryAlarmNum();

			// 			}
			// 			console.log("set showAlarmNumBtn",localStorage.getItem('showAlarmNumBtn'));
			// 		}
			// 	})
			// }
	  },

};
</script>

<style>
</style>
